import type { CSSProperties } from 'react';
import { Chip, type EstadoChip } from '../componentes/Chip';
import { Icono } from '../componentes/Icono';
import type { EstadoSuscripcion } from '../api/operaciones';
import { COLORES_TONO, type ElementoCampana } from './avisosCampana';

/**
 * Piezas que comparten los dos marcos (0.1, 0.2): avatar, etiqueta de estado del negocio, tarjetas de la campana y filas
 * de negocios.
 */

/** Etiqueta de estado del negocio, solo si no es activa ni en prueba (G112), con la etiqueta común (RvChip). */
const ESTADO_NEGOCIO: Partial<Record<EstadoSuscripcion, [string, EstadoChip]>> = {
    past_due: ['Impagada', 'problem'],
    suspended: ['Suspendida', 'problem'],
    paused: ['Pausada', 'neutral'],
    cancel_scheduled: ['Baja programada', 'pending'],
    cancelled: ['Cancelada', 'problem'],
    trial_expired: ['Prueba caducada', 'problem'],
    closed: ['Cerrada', 'problem'],
};

export function EtiquetaEstado({ estado }: { estado: EstadoSuscripcion }) {
    const e = ESTADO_NEGOCIO[estado];
    return e === undefined ? null : <Chip estado={e[1]}>{e[0]}</Chip>;
}

export function Avatar({ texto, tamano, fondo, tinta, letra = 12 }: { texto: string; tamano: number; fondo: string; tinta: string; letra?: number }) {
    return (
        <span className="rv-avatar" style={{ width: tamano, height: tamano, background: fondo, color: tinta, fontSize: letra }}>
            {texto}
        </span>
    );
}

export function TarjetaAviso({ e, onClick, onAccion, style, sombra = false }: { e: ElementoCampana; onClick?: () => void; onAccion?: () => void; style?: CSSProperties; sombra?: boolean }) {
    const c = COLORES_TONO[e.tono];
    return (
        <div
            role="button"
            tabIndex={0}
            className="rv-aviso"
            style={{ background: c.fondo, color: c.tinta, cursor: onClick === undefined ? 'default' : 'pointer', boxShadow: sombra ? 'var(--rv-shadow-3)' : 'none', ...style }}
            onClick={onClick}
            onKeyDown={(ev) => {
                if (ev.key === 'Enter') {
                    onClick?.();
                }
            }}
        >
            <span className="rv-aviso__baldosa" style={{ background: c.baldosa }}>
                <Icono nombre={e.icono} />
            </span>
            <span className="rv-aviso__textos">
                <span className="rv-aviso__fila">
                    <span className="rv-aviso__titulo">{e.titulo}</span>
                    <span className="rv-aviso__hora" style={{ color: c.sub }}>
                        {e.hora}
                    </span>
                </span>
                {e.texto !== '' && (
                    <span className="rv-aviso__texto" style={{ color: c.sub }}>
                        {e.texto}
                    </span>
                )}
                {e.accion !== null && onAccion !== undefined && (
                    <button
                        type="button"
                        className="rv-aviso__accion"
                        onClick={(ev) => {
                            ev.stopPropagation();
                            onAccion();
                        }}
                    >
                        {e.accion}
                        <Icono nombre="arrow-right" />
                    </button>
                )}
            </span>
        </div>
    );
}
